export default `<html>
  <head>
    <link rel="icon" href="/images/favicon.ico">
    <title>Hotmart</title>
    <style>
      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }

        100% {
          transform: rotate(360deg);
        }
      }

      @keyframes spinrevert {
        0% {
          transform: rotate(0deg);
        }

        100% {
          transform: rotate(-360deg);
        }
      }

      .main-holder {
        opacity: 0;
        transition: opacity .2s ease .2s;
        will-change: opacity;
        pointer-events: none;
      }

      .main-holder.loaded {
        opacity: 1;
        pointer-events: auto;
        overflow: visible;
      }

      html:before {
        content: '';
        width: 18px;
        height: 30px;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAZCAYAAAA8CX6UAAAABGdBTUEAALGPC/xhBQAAAulJREFUOBGNVEtIVGEUPufeO6OT2oNBRTJsUxuDsghKDDMflDW6KGfTKkJqEQi1KYMiIoJs1bJW0mPhC6YZBnVGB8pFhBAuXESERpAQYdBMOnrn/qfzT/2Xf5iZnAtzzznf+c53/8c5g7DFM5JIVELSvm6a5vD5s+1fitGxWELi45Nv6jKb6WkktIO9nYf/xzWKJYkInc30MBAcIKCPxXgKLyo0Fo5fI4JOSUTEalUQjb7brnzdFhSan5/38IpuacTW8WiiXsYpO/lqIh73a7msmyc0srjo/fxt9QIB1Ckyi1pOJvNiNDzTxdgp57e4p3LK5giNhGMt1tL3/Qh4WRGUZbFWIZwpPi8fIQQ5zql1by0UitemkRZMNPoFiRAT3ZwS0y16jEZ0sL4v0D4tcVd1A8UDIKp1hPN6K5GsoC1eknCeT4RnD7pCMuAbupQllPjiMzzEv5qMyNx2hWxyBjhwV1eiVpZGiIHQ3FwVyld6dW2FG68iXwBtBFrkRlrnPK+AfPkc7jMDLxr26npXIRE+6TH0lO0O9nY1BXs6m6G6wm8gPCkoJOCERYBHgZVyH0z09XQEuaPdRLC5eZ05A6OhmE8A9et8XmmTIYiO6KD0LYRBXUTPlxvWoB5nfcR6Xi3U6gmOHZ+194OO6X4g0PaD42Ud4w1VGoT0Swd5L2YKVgoOpuTJHuPO36nXMLpmsNrXXJCjTPp0HvYPGI3MHOMzyRFi6S8GmBjLKyJ4rKZdz8lWARLPdEz6BlIMI5G3u9ac9BJ/ZUcOAeEn/zPeAQ/Ogm1uAtrHuWPu89YadJ48U/BajWwBeOpvkqCHOqFUn2/3KffZlb9jca5jiL82VWqxy0NYgCrrhoyzQtx5Trnf18fqEZe0hcNX997ylp8JtrWlJDW7NVXD+zfGwjNXicRdboMaheuWrz7J0zBU5Wl41N29b0PlcoQUGI1+KkuJ5Q4UcJIF93DzGLwCOdhzXv+2yd6WlqTiKvsHCFQcgJgP8XMAAAAASUVORK5CYII=');
        background-size: 100% auto;
        background-repeat: no-repeat;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        z-index: 100;
        transition: opacity .2s ease .2s;
      }

      body.loaded-completed:before,
      body.loaded-completed:after {
        content: none;
      }

      body:before,
      body:after {
        content: '';
        width: 50px;
        height: 50px;
        background: #fff;
        border: 1px transparent solid;
        border-top-color: #dce0e3;
        border-left-color: #dce0e3;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        z-index: 50;
        pointer-events: none;
        border-radius: 50%;
        transition: opacity .2s ease .2s;
        animation: spin 500ms linear 0s infinite;
      }

      body:after {
        width: 40px;
        height: 40px;
        border-top-color: #A9B1BA;
        border-left-color: #A9B1BA;
        animation: spinrevert 750ms linear 0s infinite;
      }

      .first-loading.loaded,
      body.loaded:before,
      body.loaded:after,
      html.loaded:before {
        opacity: 0;
        display: none;
      }
    </style>
    <style type="text/css">
      body.gdpr_body {
        height: 100vh !important;
        background: #FFF !important;
      }

      .gdpr_content {
        font-family: 'Open Sans' !important;
        max-width: 500px !important;
        padding: 1rem !important;
        margin: 0 auto !important;
      }

      .gdpr_logo {
        width: 200px !important;
        margin: 0 auto !important;
        padding: 1rem 1rem 0 1rem !important;
      }

      .gdpr_title {
        font-weight: 500 !important;
        line-height: 1.1 !important;
        color: #444444 !important;
        text-align: center !important;
        font-size: 2.5rem !important;
      }

      .gdpr_text {
        font-size: 1rem !important;
        font-weight: 400 !important;
        line-height: 1.5 !important;
        color: #444444 !important;
        background-color: white !important;
      }

      .gdpr_text a {
        color: #f04e23
      }

      .gdpr_btn {
        font-size: 1rem !important;
        margin-bottom: 2rem !important;
        font-weight: 700 !important;
        cursor: pointer !important;
        line-height: 1.2rem !important;
        padding: 0.5rem 1rem !important;
        transition: all 500ms cubic-bezier(0.2, 1, 0.22, 1) !important;
      }

      .gdpr_accept-btn {
        border-radius: 0.25rem !important;
        background-color: #79a52e !important;
        color: #FFF !important;
        border-color: #739d2c !important;
        cursor: pointer !important;
        outline: 0 none !important;
        text-align: center !important;
        white-space: nowrap !important;
        vertical-align: middle !important;
        border: 1px solid transparent !important;
        text-shadow: none !important;
        float: right !important;
        margin-top: 1rem !important;
      }

      .gdpr_accept-btn:disabled {
        opacity: .4;
        cursor: unset !important;
      }

      @keyframes gdpr_spinrevert {
        0% {
          transform: rotate(0deg);
        }

        100% {
          transform: rotate(-360deg);
        }
      }

      @keyframes gdpr_spin {
        0% {
          transform: rotate(0deg);
        }

        100% {
          transform: rotate(360deg);
        }
      }

      #gdpr_loading {
        display: none;
      }

      .gdpr_loading-wrapper {
        float: right;
        position: relative;
        color: #093D4D;
        margin-right: 1rem;
      }

      .gdpr_loading-wrapper .gdpr_loading-fire svg {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -12px;
        margin-left: -8px;
        width: 16px;
      }

      .gdpr_loading-wrapper .gdpr_loading-fire svg path {
        fill: #A9B1BA;
        transition: all 500ms cubic-bezier(.20, 1, .22, 1);
      }

      .gdpr_loading-activity {
        display: block;
        position: relative;
        margin: 0 auto;
        width: 40px;
        height: 40px;
        border: 1px solid transparent;
        border-top-color: #DCE0E3;
        border-left-color: #DCE0E3;
        border-radius: 100%;
        animation: gdpr_spin 500ms linear 0s infinite;
      }

      .gdpr_loading-activity.gdpr_revert {
        width: 30px;
        height: 30px;
        border-top-color: #A9B1BA;
        border-left-color: #A9B1BA;
        animation: gdpr_spinrevert 750ms linear 0s infinite;
        position: absolute;
        top: 5px;
        left: 5px;
      }
    </style>
  </head>
  <body></body>
</html>`;
